import { render, staticRenderFns } from "./KnowledgeBaseList.vue?vue&type=template&id=698fd8ed&scoped=true&lang=pug&"
import script from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseList.vue?vue&type=style&index=0&id=698fd8ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698fd8ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
